import { Fonts } from "@brg/ui";
import styled, { css } from "styled-components";
import { LayoutConst } from "../../../core";

export const RectangularButton = styled.button<{ fixedSize?: boolean }>`
    // ${Fonts.Inter.text};
    font-family: Inter, sans-serif;
    font-size: 17px;
    line-height: 22px;
    margin: 0;
    font-weight: 700;
    outline: none !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    height: 38px;
    padding: 6px 38.5px;
    background: transparent;

    /* main geo/White31 */
    border: none;
    box-sizing: border-box;
    border-radius: 3px;
    transition: all 0.2s;

    min-width: 132px;
    user-select: none;

    /* main geo/White73 */
    color: #c5c6c7;

    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.l_16}px) {
        font-size: 15px;
        line-height: 20px;
        height: 30px;
        // padding: 8px 19px;
    }
    
    @media (max-width: ${LayoutConst.screen.m}px) {
        display: flex;
        height: ${p => p?.fixedSize ? 'inherit': '26px !important'};
        align-items: center;
        justify-content: center;
        // padding: 4px 16px;
        border-radius: 3px;
        font-family: Inter, sans-serif;
        font-style: normal;
        font-weight: 700 !important;
        // font-size: 13px;
        // line-height: 18px;
        // margin-right: 12px;
    }
`;

export const RectangularButtonHollow = styled(RectangularButton)<{ isGeoActive?: boolean }>`
    color: ${(p) => p.isGeoActive ? '#151514' : p.theme.navigationBar.btns.hollow.text.main};
    border: 1px solid ${({theme}) => theme.navigationBar.btns.hollow.border.main};
    background-color: ${p => p.isGeoActive ? 'rgb(164, 181, 77)': 'inherit'};
    &:hover {
        border: 1px solid ${({theme}) => theme.navigationBar.btns.hollow.border.hover};
    }

    &:active {
        border: 1px solid ${({theme}) => theme.navigationBar.btns.hollow.border.active};
    }
    &:disabled {
        cursor: not-allowed;
        color: ${({theme}) => theme.navigationBar.btns.hollow.text.disabled};
        background-color: ${({theme}) => theme.navigationBar.btns.hollow.background.disabled};
        border: 0px solid ${({theme}) => theme.navigationBar.btns.hollow.border.disabled};
    }
`

export const RectangularButtonFilled = styled(RectangularButton)<{ importantStyles?: boolean, smallPadding?: boolean, isTagEditPage?: boolean }>`
    color: ${({theme}) => theme.navigationBar.btns.filled.text.main};
    background: ${({theme}) => theme.navigationBar.btns.filled.background.main};
    ${p => p.importantStyles ? css`
        color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
        background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}
    ${p => p.isTagEditPage ? css`
        color: ${({theme}) => theme.tags.tagEditModal.buttons.edit.color};
        background: none;
        border: 1px solid ${({theme}) => theme.tags.tagEditModal.buttons.edit.borderColor};
    ` : null}
    &:hover {
        background: ${({theme}) => theme.navigationBar.btns.filled.background.hover};

        ${p => p.importantStyles ? css`
            color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
            background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.hover};
            // border: 1px solid rgb(144, 144, 144);
    ` : null}
        ${p => p.isTagEditPage ? css`
            background: none;
        ` : null}
    }

    &:active {
        background: ${({theme}) => theme.navigationBar.btns.filled.background.active};
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.31);

        ${p => p.importantStyles ? css`
        color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
        background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}
        ${p => p.isTagEditPage ? css`
            background: none;
            box-shadow: none;
        ` : null}
    }
    &:disabled {
        cursor: not-allowed;
        color: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};
        background: ${({theme}) => theme.navigationBar.btns.filled.background.disabled};

        ${p => p.importantStyles ? css`
        color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
        background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.active};
    ` : null}
        ${p => p.isTagEditPage ? css`
            color: ${({theme}) => theme.tags.tagEditModal.buttons.edit.color};
            background: none;
        ` : null}
    }

    ${({ smallPadding }) => smallPadding && css`
            padding-left: 10px;
            padding-right: 10px;
    `};
`

export const CustomHollowButton = styled(RectangularButtonHollow)`
    // color: ${({theme}) => theme.navigationBar.btns.hollow.text.grey};
    border: 1px solid #575B5E;
    border-radius: 3px;

    // &:hover {
    //     color: ${({theme}) => theme.navigationBar.btns.hollow.text.black};
    // }
`import { Fonts } from "@brg/ui";
import styled, { css } from "styled-components";
import { LayoutConst } from "../../../core";

export const RectangularButton = styled.button<{ fixedSize?: boolean }>`
    // ${Fonts.Inter.text};
    font-family: Inter, sans-serif;
    font-size: 17px;
    line-height: 22px;
    margin: 0;
    font-weight: 700;
    outline: none !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    height: 38px;
    padding: 6px 38.5px;
    background: transparent;

    /* main geo/White31 */
    border: none;
    box-sizing: border-box;
    border-radius: 3px;
    transition: all 0.2s;

    min-width: 132px;
    user-select: none;

    /* main geo/White73 */
    color: #c5c6c7;

    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.l_16}px) {
        font-size: 15px;
        line-height: 20px;
        height: 30px;
        // padding: 8px 19px;
    }
    
    @media (max-width: ${LayoutConst.screen.m}px) {
        display: flex;
        height: ${p => p?.fixedSize ? 'inherit': '26px !important'};
        align-items: center;
        justify-content: center;
        // padding: 4px 16px;
        border-radius: 3px;
        font-family: Inter, sans-serif;
        font-style: normal;
        font-weight: 700 !important;
        // font-size: 13px;
        // line-height: 18px;
        // margin-right: 12px;
    }
`;

export const RectangularButtonHollow = styled(RectangularButton)<{ isGeoActive?: boolean }>`
    color: ${(p) => p.isGeoActive ? '#151514' : p.theme.navigationBar.btns.hollow.text.main};
    border: 1px solid ${({theme}) => theme.navigationBar.btns.hollow.border.main};
    background-color: ${p => p.isGeoActive ? 'rgb(164, 181, 77)': 'inherit'};
    &:hover {
        border: 1px solid ${({theme}) => theme.navigationBar.btns.hollow.border.hover};
    }

    &:active {
        border: 1px solid ${({theme}) => theme.navigationBar.btns.hollow.border.active};
    }
    &:disabled {
        cursor: not-allowed;
        color: ${({theme}) => theme.navigationBar.btns.hollow.text.disabled};
        background-color: ${({theme}) => theme.navigationBar.btns.hollow.background.disabled};
        border: 0px solid ${({theme}) => theme.navigationBar.btns.hollow.border.disabled};
    }
`

export const RectangularButtonFilled = styled(RectangularButton)<{ importantStyles?: boolean, smallPadding?: boolean, isTagEditPage?: boolean }>`
    color: ${({theme}) => theme.navigationBar.btns.filled.text.main};
    background: ${({theme}) => theme.navigationBar.btns.filled.background.main};
    ${p => p.importantStyles ? css`
        color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
        background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}
    ${p => p.isTagEditPage ? css`
        color: ${({theme}) => theme.tags.tagEditModal.buttons.edit.color};
        background: none;
        border: 1px solid ${({theme}) => theme.tags.tagEditModal.buttons.edit.borderColor};
    ` : null}
    &:hover {
        background: ${({theme}) => theme.navigationBar.btns.filled.background.hover};

        ${p => p.importantStyles ? css`
            color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
            background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.hover};
            // border: 1px solid rgb(144, 144, 144);
    ` : null}
        ${p => p.isTagEditPage ? css`
            background: none;
        ` : null}
    }

    &:active {
        background: ${({theme}) => theme.navigationBar.btns.filled.background.active};
        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.31);

        ${p => p.importantStyles ? css`
        color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
        background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}
        ${p => p.isTagEditPage ? css`
            background: none;
            box-shadow: none;
        ` : null}
    }
    &:disabled {
        cursor: not-allowed;
        color: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};
        background: ${({theme}) => theme.navigationBar.btns.filled.background.disabled};

        ${p => p.importantStyles ? css`
        color: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
        background: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.active};
    ` : null}
        ${p => p.isTagEditPage ? css`
            color: ${({theme}) => theme.tags.tagEditModal.buttons.edit.color};
            background: none;
        ` : null}
    }

    ${({ smallPadding }) => smallPadding && css`
            padding-left: 10px;
            padding-right: 10px;
    `};
`

export const CustomHollowButton = styled(RectangularButtonHollow)`
    // color: ${({theme}) => theme.navigationBar.btns.hollow.text.grey};
    border: 1px solid #575B5E;
    border-radius: 3px;

    // &:hover {
    //     color: ${({theme}) => theme.navigationBar.btns.hollow.text.black};
    // }
`